import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tabPanel: {
    background: 'white',
    position: 'absolute',
    top: -260,
    left: 370,
    width: '130%',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    padding: '52px 54px 50px',
    zIndex: 2,
    [theme.breakpoints.up(1055)]: {
      top: -200,
      left: 400,
    },
    [theme.breakpoints.up(1200)]: {
      paddingBottom: 24,
      top: -230,
      left: 450,
      width: '125%',
    },
    [theme.breakpoints.up(1340)]: {
      top: -150,
      paddingBottom: 50,
      width: 844,
    },
    color: theme.palette.secondary.main,
  },
  middle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '2rem',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: ({ offset }) => `${offset + 20}px`,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '1rem',
    },
    '&>p': {
      color: theme.palette.text.primary,
    },
  },
  richTextWrapper: {
    padding: 0,
    '&>div>div>a': {
      color: theme.palette.blue.main,
      fontWeight: 700,
      boxShadow: 'none',
      textDecoration: 'underline',
    },
  },
  left: {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  right: {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  bottom: {
    borderRadius: '0 0 8px 8px',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    background: theme.palette.background.default,
    position: 'absolute',
    bottom: '0',
    left: 0,
    right: 0,
    padding: '32px 54px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  bottomText: {
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&>p>div>div': {
      marginBottom: '0 !important',
    },
    '&>div>div': {
      marginBottom: '0 !important',
    },
    '&>p>div>div>a': {
      boxShadow: 'none',
    },
    '&>p>div>div>a>u': {
      color: theme.palette.blue.main,
      fontWeight: 700,
    },
    '&>div>div>a': {
      color: theme.palette.blue.main,
      fontWeight: 700,
      boxShadow: 'none',
      textDecoration: 'underline',
    },
  },
  ctaButton: {
    paddingRight: 0,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  },
  tabPanelHeading: {
    ...theme.typography.h5,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: 0,
  },
  tabPanelsupportiveCopy: {
    color: theme.palette.text.primary,
    [theme.breakpoints.up(1400)]: {
    },
  },
}))

export default useStyles
